import {Observable, Scheduler}                           from 'rxjs';
import {distinctUntilChanged, filter, map, throttleTime} from 'rxjs/operators';

import Playback from '../../Playback/Playback';

const BANDWIDTH_WRITE_INTERVAL_DURATION = 10000;

const createEstimatedBandwidthWriteStream = (
    playbackUpdate$: Observable<Playback>,
    scheduler?: Scheduler
): Observable<number> =>
    playbackUpdate$
        .pipe(
            map(({estimatedBandwidth}) => estimatedBandwidth),
            filter(estimatedBandwidth => estimatedBandwidth > 0),
            throttleTime(BANDWIDTH_WRITE_INTERVAL_DURATION, scheduler),
            distinctUntilChanged()
        );

export default createEstimatedBandwidthWriteStream;
